<template>
  <Container judul="Beranda">
    <template #header>
      <HeaderFe />
    </template>
    <template v-slot:default>
      <div class="min-h-screen pb-16 bg-gray-50/40">
        <main class="pt-28">
          <!-- Dynamic Widgets -->
          <template v-if="
            activeWidgets &&
            activeWidgets.data &&
            activeWidgets.data.length > 0
          ">
            <div v-for="widget in activeWidgets.data" :key="widget.id" class="mb-8">
              <WidgetComponent :widget="widget" />
            </div>
          </template>

          <!-- Fallback widgets if no dynamic widgets are active -->
          <template v-else>
            <AgendaSection :agenda="agenda" />
            <AuthorSection :formasi="formasi" />
            <BlogSection :news="news" />

            <!-- Gallery on homepage -->
            <div v-if="galleryImages.length" class="mb-8">
              <h2 class="mb-3 text-xl font-semibold text-gray-900">Galeri</h2>
              <CarouselGalery :galery="galleryImages" />
            </div>
            <GraphSection :grafik="grafik" />
          </template>
        </main>
      </div>
    </template>
    <template #footer>
      <FooterFe class="mt-auto" />
    </template>
  </Container>
</template>

<script setup>
import { defineProps, provide, computed } from "vue";
import Container from "@/Layouts/Container.vue";
import HeaderFe from "@/Components/HeaderFe.vue";
import FooterFe from "@/Components/FooterFe.vue";

// Import komponen widget yang diperlukan untuk fallback
import AgendaSection from "@/Components/Web/AgendaSection.vue";
import AuthorSection from "@/Components/Web/AuthorSection.vue";
import BlogSection from "@/Components/Web/BlogSection.vue";
import GraphSection from "@/Components/Web/GraphSection.vue";
import CarouselGalery from "@/Components/Web/CarouselGalery.vue";

// Import komponen loader widget
import WidgetComponent from "@/Components/Web/WidgetLoader/WidgetComponent.vue";

const props = defineProps({
  formasi: {
    type: Object,
    required: true,
  },
  news: {
    type: Object, // Using Object since it's coming as { data: [...] }
    required: true,
  },
  slider: {
    type: Object, // Using Object since it's coming as { data: [...] }
    required: true,
  },
  agenda: {
    type: Object, // Using Object since it's coming as { data: [...] }
    required: true,
  },
  grafik: {
    type: Object, // Using Object since it's coming as { data: [...] }
    required: true,
  },
  profil: {
    type: Object, // Using Object since it's coming as { data: [...] }
    required: true,
  },
  galery: {
    type: Object,
    default: () => ({ data: [] }),
  },
  activeWidgets: {
    type: Object, // Changed to Object since it's coming as { data: [...] }
    default: () => ({ data: [] }),
  },
  linkmedsos: {
    type: Object, // Changed to Object since it's coming as { data: [...] }
    default: () => ({ data: [] }),
  },
});

// Provide all data to be available to child components (specifically WidgetComponent)
provide("formasi", props.formasi);
provide("news", props.news);
provide("slider", props.slider);
provide("agenda", props.agenda);
provide("grafik", props.grafik);
provide("galery", props.galery);
provide("profil", props.profil);
provide("linkmedsos", props.linkmedsos);

// Derive images from latest gallery for homepage carousel
const galleryImages = computed(() => {
  const list = props.galery?.data || [];
  if (!Array.isArray(list) || list.length === 0) return [];
  const first = list[0] || {};
  const paths = Array.isArray(first.image_path) ? first.image_path : [];
  return paths.map((p) => (typeof p === "string" ? p : (p?.url || p?.src || ""))).filter(Boolean);
});
</script>
